import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  wrapButton: {
    display: "flex",
    justifyContent: "center",
    paddingBottom: "70px",
    marginTop: "50px",
  },
  listPadding: {
    paddingBottom: 0,
  },
  list: {
    backgroundColor: "#f0f0f0",
    fontWeight: "bold",
  },
  wrapList: {
    paddingBottom: "70px",
  },
  wrapHeader: {
    display: "flex",
    paddingTop: "60px",
    justifyContent: "center",
  },
  wrapAvatar: {
    display: "flex",
    alignItems: "center",
  },
  btnTokoSaya: {
    display: "flex",
    marginBottom: 25,
    justifyContent: "center",
    marginTop: 15
  },
  large: {
    width: 80,
    height: 80,
    border: "2px solid #5675D3",
  },
}));

export default useStyles;
